/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Select_GrowerInputs */

const vi_tea_purchase_select_grower = /** @type {(inputs: Tea_Purchase_Select_GrowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn hộ trồng`)
};

/**

* @param {Tea_Purchase_Select_GrowerInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_select_grower = /** @type {((inputs?: Tea_Purchase_Select_GrowerInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Select_GrowerInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_select_grower(inputs)
});